import Section from '../base/Section';
import Button from '../base/Button';

export default function CTASection() {
  return (
    <Section background="gradient" padding="lg">
      <div className="text-center max-w-4xl mx-auto px-4">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-6">
          ¿Necesitas vaciar un piso en Granollers?
        </h2>
        <p className="text-lg sm:text-xl md:text-2xl mb-10 text-white/90">
          Presupuesto gratis en menos de 24 horas. Servicio profesional, discreto y eficiente en todo el Vallès Oriental. Conoce más sobre <a href="/empresa" className="underline hover:text-primary transition-colors cursor-pointer">nuestra empresa</a> y <a href="/servicios" className="underline hover:text-primary transition-colors cursor-pointer">nuestros servicios</a>.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Button 
            variant="white" 
            size="lg"
            onClick={() => window.location.href = '/contacto'}
            icon={<i className="ri-send-plane-line"></i>}
          >
            Solicitar Presupuesto
          </Button>
          <Button 
            variant="outline" 
            size="lg"
            onClick={() => window.location.href = 'tel:+34602365996'}
            icon={<i className="ri-phone-line"></i>}
            className="border-white text-white hover:bg-white hover:text-primary"
          >
            Llamar 602 36 59 96
          </Button>
        </div>

        <div className="mt-12 flex flex-wrap justify-center gap-4 sm:gap-8 text-sm px-4">
          <div className="flex items-center gap-2">
            <i className="ri-checkbox-circle-fill text-white text-xl w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
            <span>Sin Compromiso</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-checkbox-circle-fill text-white text-xl w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
            <span>Respuesta en 24h</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-checkbox-circle-fill text-white text-xl w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
            <span>Servicio Profesional</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-checkbox-circle-fill text-white text-xl w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
            <span>Máxima Discreción</span>
          </div>
        </div>
      </div>
    </Section>
  );
}
